"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_usestateref_1 = __importDefault(require("react-usestateref"));
const defaultState = {
    isDone: false,
    isLoading: false,
};
function useIndicators() {
    const [state, setObject, stateRef] = (0, react_usestateref_1.default)(defaultState);
    function resetIndicators() {
        setIndicators(defaultState);
    }
    function setIndicators(data) {
        setObject(Object.assign(Object.assign({}, state), data));
    }
    return {
        state,
        stateRef,
        set: setIndicators,
        reset: resetIndicators,
    };
}
exports.default = useIndicators;
